import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import { createMyVuetify } from './plugins/vuetify';
import { iframeDataBridge } from './iframe/iframeDataBridge';
import { ssoPostHandler } from './utils/ssoPostHandler';
import { AllEnterpriseModule, ModuleRegistry } from 'ag-grid-enterprise';
import { initializeSync } from './sync/dataSync';
import { registerServiceWorker } from './utils/registerServiceWorker';
import { initializeAgGridEnterprise } from './utils/agGridEnterprise';
import { preloadMaterialIconsFont } from './utils/materialIconsPreloader';

import './styles/root.scss';
import './styles/main.scss';

const app = createApp(App);

if (import.meta.env.DEV) {
	app.config.devtools = true;
}

ModuleRegistry.registerModules([AllEnterpriseModule]);

const rawLocale = iframeDataBridge.getCurrentUser()?.language || 'fr-FR';
const userLocale = rawLocale.split('-')[0];

app.use(router);
app.use(createMyVuetify(userLocale));
app.mount('#app');
initializeAgGridEnterprise();
void preloadMaterialIconsFont();

import { initIframeViewObserver } from './iframe/iframeWatcher';
initIframeViewObserver();

iframeDataBridge.initSSOListener();
ssoPostHandler.init();

initializeSync().catch(console.error);

registerServiceWorker();
